import { useQuery } from "@apollo/client";
import { graphql } from "gql/apollo";
import { resolveStreamFragmentData } from "../resolveStreamFragmentData";

export const GetStream = graphql(/* GraphQL */ `
	query getStreamApollo($params: GetStreamParams!) {
		newGetStream(params: $params) {
			__typename
			_id
			gid
			name
			share_type
			is_owner
			transferred_date
			type
			criterion_updated
			owner {
				gid
				name
			}
			... on StandardStream {
				...standardStreamFields
			}
			... on IncidentStream {
				...incidentStreamFields
			}
			... on WebAlertsStream {
				...webAlertsStreamFields
			}
			... on DarkWebStream {
				...darkWebStreamFields
			}
		}
	}
`);

export const useGetStream = (streamId: string, skip = false) => {
	const { data, loading, error } = useQuery(GetStream, {
		variables: {
			params: {
				_id: streamId,
			},
		},
		skip,
	});

	return {
		stream:
			data?.newGetStream ?
				resolveStreamFragmentData(data.newGetStream)
			:	undefined,
		loading,
		error,
	};
};
